import './GaugeLabelsWrapper.css';
export var labelsContainer = '_1fbjcz30-3-5-0';